import React from 'react';
import {useTranslation} from 'react-i18next';

import useGroup from 'hooks/useGroup';
import useSession from 'hooks/useSession';

function DeleteGroup(props) {
	const {t} = useTranslation();

	const {
		group,
		deleteGroup
	} = useGroup();

	const {
		session,
		defaultGroup
	} = useSession();


	if (group && group.id && group.id === defaultGroup.id) {
		return (null);
	}
	return (
		<button
			className={'btn btn-icon btn-icon-only btn-outline-primary mb-1'}
			type="button"
			onClick={() => {
				if (window.confirm(t('DeleteGroup.confirm'))) {
					props.setFetchingGroup(true);
					deleteGroup({
						groupId: group.id,
						session
					}, () => {
						props.setFetchingGroup(false);
					});
				}
			}}
		>
			<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
			     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
				<polyline points="3 6 5 6 21 6"></polyline>
				<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
				<line x1="10" y1="11" x2="10" y2="17"></line>
				<line x1="14" y1="11" x2="14" y2="17"></line>
			</svg>
		</button>
	);
}

export default DeleteGroup;
